import vue from 'vue'
// import tabsTool from "saaf-common/tool/tabsTool";
//import {sessionStorageTool, store, tabsTool, getUrl, localStorageTool, AESCommon} from 'saaf-common'
//import { debounce } from "view-design/src/components/select/utils";
import platform from '@/config/platform';
import {fetch, api} from '@/page/index'
import axios from 'axios'
import  fetchTool from "@/common/tool/fetchTool";

class SrmCommonUtils {

    constructor(vm) {
        this.vm = vm
    }

    getLookupValues(lookupType) {
        /*let defaultStr = []
        let valueStr = window.localStorage.getItem("BASE_lookup")
        if(!!!valueStr){
            return defaultStr
        }
        let valuesJson = JSON.parse(valueStr)*/
        let _valuesJson = this.vm.$store.state.user.dicCodes
        return _valuesJson[lookupType]
    }
    getLookupValuesRow(lookupType, lookupValue) {
        let lookupValueJson = this.getLookupValues(lookupType)

        if (!!!lookupValueJson) {
            return {lookupCode: lookupValue}
        }
        for (let i = 0; i < lookupValueJson.length; i++) {
            if (lookupValue === lookupValueJson[i]["lookupCode"]) {
                return lookupValueJson[i]
            }
        }
        return {lookupCode: lookupValue}
    }
    getLookupMeaning(lookupType, lookupValue) {
        let _row = this.getLookupValuesRow(lookupType, lookupValue)
        if (_row["meaning"] === undefined) {
            return lookupValue
        }
        return _row["meaning"]
    }
    getLookupValuesItem(lookupType, lookupValue, field) {
        let _row = this.getLookupValuesRow(lookupType, lookupValue)
        if (_row[field] === undefined) {
            return lookupValue
        }
        return _row[field]
    }
    getBtnColor(recCode) {
        let color = "#139fee"
        switch(recCode) {
            case "btnDel":
                color = "#ee150b"
                break
            case "error":
                color = "#ee150b"
                break
            case "btnSave":
                color = "#23ee13"
                break
            case "disabled":
                color = "#eaeaea"
                break
            case "notData":
                color = "#ababab"
                break
            default:
                color = "#139fee"
                break
        }
        return color
    }
    setDyModalTop(modalType) {
        let _modalType = modalType
        // 重新计算模态模显示位置
        this.vm.$nextTick(() => {
            let _target = document.getElementsByClassName("ivu-modal ease-enter ease-enter-active")
            if (!!_target && _target.length > 0) {
                let _screenHeight = this.vm.$store.state.system.screenHeight
                if (_screenHeight <= 0) {
                    _screenHeight = document.getElementsByTagName("body")[0].offsetHeight
                }
                let _top = (_screenHeight - _target[0].offsetHeight) / 2 - 40
                _target[0].style.top = _top + "px"
                let _targetIcon = _target[0].querySelector(".ivu-icon.ivu-icon-ios-help-circle")
                if (!!_targetIcon && _modalType === "error") {
                    _targetIcon.style.color = this.getBtnColor("error")
                }
            }
        })
    }

    /**
     * description 创建警告提醒提示框
     * @param title   提示标题
     * @param content  提示内容（红色字体）
     * @param onOkFun   确认后回调方法
     * @param onCancelFun  退出回调方法（默认可不传参）
     */
    createErrorModal(title, content, onOkFun, onCancelFun) {
        this.vm.$Modal.confirm({
            title: title,
            closable: true,
            onOk: onOkFun,
            onCancel: !!!onCancelFun ? () => {} : onCancelFun,
            render: (h, params) => {
                return h("div", {
                        style: {
                            "color": "#ff0c10",
                            "padding": "10px 10px",
                            "text-align": "center",
                            "font-size": "16px",
                            "font-weight": 700
                        }
                    },
                    content
                )
            }
        })
        this.setDyModalTop("error")
    }

    /**
     * description 创建确认提醒提示框
     * @param title   提示标题
     * @param content  提示内容
     * @param onOkFun   确认后回调方法
     * @param onCancelFun  退出回调方法（默认可不传参）
     */
    createConfirmModal(title, content, onOkFun, onCancelFun) {
        this.vm.$Modal.confirm({
            title: title,
            closable: true,
            onOk: onOkFun,
            onCancel: !!!onCancelFun ? () => {} : onCancelFun,
            render: (h, params) => {
                return h("div", {
                        style: {
                            "padding": "10px 10px",
                            "text-align": "center",
                            "font-size": "16px",
                            "font-weight": 700
                        }
                    },
                    content
                )
            }
        })
        // 重新计算模态模显示位置
        this.setDyModalTop()
    }
    /*设置当前显示的Modal框垂直居中*/
    setModalHCenter() {
        this.vm.$nextTick(() => {
            let _modalList = document.querySelectorAll(".ivu-modal-wrap.saaf-ivu-modal-mask.ivu-modal-no-mask")
            if (!!_modalList && _modalList.length > 0) {
                for (let i = 0; i < _modalList.length; i++) {
                    let _targetClassList = _modalList[i].classList
                    let _hiddenModal = false
                    for (let j = 0; j < _targetClassList.length; j++) {
                        if (_targetClassList[j] === "ivu-modal-hidden") {
                            _hiddenModal = true
                            break;
                        }
                    }
                    if (!_hiddenModal) {
                        let _targetModal = _modalList[i].querySelector(".ivu-modal")
                        let _targetContent = _modalList[i].querySelector(".ivu-modal-content")
                        if (!!_targetModal && !!_targetContent) {
                            let _screenHeight = this.vm.$store.state.system.screenHeight
                            if (_screenHeight <= 0) {
                                _screenHeight = document.body.offsetHeight
                            }
                            let _top = (_screenHeight - _targetContent.offsetHeight) / 2
                            if (_top < 0) {
                                _top = 10
                            }
                            _targetContent.style.top = _top + "px"
                        }
                    }
                }
            }
        })
    }
    //乘
    numberMul(a, b) {
        var c = 0,
            d = a.toString(),
            e = b.toString();
        try {
            c += d.split(".")[1].length;
        } catch (f) {
        }
        try {
            c += e.split(".")[1].length;
        } catch (f) {
        }
        return Number(d.replace(".", "")) * Number(e.replace(".", "")) / Math.pow(10, c);
    }
    //加
    numberAdd(a, b) {
        var c, d, e;
        try {
            c = a.toString().split(".")[1].length;
        } catch (f) {
            c = 0;
        }
        try {
            d = b.toString().split(".")[1].length;
        } catch (f) {
            d = 0;
        }
        return e = Math.pow(10, Math.max(c, d)), (this.numberMul(a, e) + this.numberMul(b, e)) / e;
    }
    // 减
    numberSub(a, b) {
        var c, d, e;
        try {
            c = a.toString().split(".")[1].length;
        } catch (f) {
            c = 0;
        }
        try {
            d = b.toString().split(".")[1].length;
        } catch (f) {
            d = 0;
        }
        return e = Math.pow(10, Math.max(c, d)), (this.numberMul(a, e) - this.numberMul(b, e)) / e;
    }
    //除
    numberDiv(a, b) {
        var c, d, e = 0,
            f = 0;
        try {
            e = a.toString().split(".")[1].length;
        } catch (g) {
        }
        try {
            f = b.toString().split(".")[1].length;
        } catch (g) {
        }
        return c = Number(a.toString().replace(".", "")), d = Number(b.toString().replace(".", "")), this.numberMul(c / d, Math.pow(10, f - e));
    }
    /* 深度COPY对象属性 */
    deepCopyObject(srcObj) {
        if (!!!srcObj) return {}
        let keys = Object.keys(srcObj)
        let targetObj ={}
        for (let i =0; i < keys.length; i++) {
            targetObj[keys[i]] = srcObj[keys[i]]
        }
        return targetObj
    }
    /* 深度COPY数组对象属性 */
    deepCopyArrayObject(srcObj) {
        if (Array.isArray(srcObj)) {
            let targetObj =[]
            for (let i = 0; i < srcObj.length; i++) {
                targetObj.push(this.deepCopyObject(srcObj[i]))
            }
            return targetObj
        } else {
            return this.deepCopyObject(srcObj)
        }
    }

    /**
     * description Array数据转换成TreeData数据
     * 参数说明：
     * @param srcArr: [] 数据数据，必须为树结构化数据，带有id, parentId, level字段的格式化数组
     * @param key   // 主键字段
     * @param parentKey  // 关联父数据行字段
     * @param levelKey //层级字段
     * @param treeConfig :{       //树结构设置
     *            treeTitle: "categoryCode-categoryName",  // tree节点名称，多字字段合并显示的，使用 - 连接起来
     *            expand: true //所有节点是否展开
     *        }
     */
    arrayToTree(srcArr, key, parentKey, levelKey, treeConfig) {
        let hasChild = (dataArr, key, parentKey, parentItem,) => {
            for (let i = 0; i < dataArr.length; i++) {
                if (parentItem[key] === dataArr[i][parentKey]) return true
            }
            return false
        }
        let getChildList = (dataArr, levelKey, parentItem) => {
            let childList = []
            for (let i = 0; i < dataArr.length; i++) {
                if (parentItem[levelKey] < dataArr[i][levelKey]) {
                    childList.push(dataArr[i])
                }
            }
            return childList
        }
        let dynamicTree = (dataArr, key, parentKey, levelKey, treeConfig, parentItem) => {
            let resultArr = []
            dataArr.forEach(item => {
                if(!!!item[parentKey] || item[parentKey] === 0 || (!!parentItem && item[parentKey] === parentItem[key])) {
                    let _obj = item
                    // 生成title数据
                    let _titleKey = treeConfig["treeTitle"].split("-")
                    let _titleValue = ""
                    for (let i = 0; i < _titleKey.length; i++) {
                        _titleValue += !!!_titleValue ? item[_titleKey[i]] : "  " + item[_titleKey[i]]
                    }
                    _obj["title"] = _titleValue
                    if (!!treeConfig && treeConfig.expand !== undefined) {
                        _obj["expand"] = treeConfig.expand
                    }
                    if (!!item["checkFlag"]) {
                        _obj["checked"] = item["checkFlag"] === "Y"
                    }
                    _obj["treeFullPath"] = !!parentItem && parentItem["treeFullPath"] ? parentItem["treeFullPath"] + "." + _obj[key].toString() : _obj[key].toString()
                    _obj = this.deepCopyObject(_obj)
                    if (hasChild(dataArr, key, parentKey, item) && (!!!parentItem || !!parentItem && parentItem[levelKey] < item[levelKey])) {
                        let childList = getChildList(dataArr, levelKey, _obj )
                        _obj.children = dynamicTree(childList, key, parentKey, levelKey, treeConfig,  _obj)
                    }
                    resultArr.push(_obj)
                }
            })
            return resultArr
        }
        if (!!!Array.isArray(srcArr)) return srcArr
        if (!!!key || !!!parentKey || !!!levelKey || !!!treeConfig) {
            throw Error("解析树结构数据失败, key, parentKey, levelKey, treeConfig参数不可为空")
        }
        let _newTreeArr = []
        _newTreeArr = dynamicTree(srcArr, key, parentKey, levelKey, treeConfig)
        return _newTreeArr
    }

    /**
     * description TreeData数据转化为Array数据
     * @param treeData
     * @returns {[]|*}
     */
    treeToArray(treeData) {
        if (Array.isArray(treeData)) {
            let _newArray = []
            let _treeData = treeData
            let _toArray = (treeArr, newArray) => {
                treeArr.forEach((item) => {
                    if (!!item.children && item.children.length > 0) {
                        let _newItem = this.deepCopyObject(item)
                        delete _newItem["children"]
                        newArray.push(_newItem)
                        _toArray(item.children, newArray)
                    } else {
                        newArray.push(item)
                    }
                })
            }
            _toArray(_treeData, _newArray)
            return _newArray
        }
        return treeData
    }

    /**
     * description 节点添加自定义字段值
     * @param treeNode
     * @param values
     * @private
     */
    _setTreeNodeValue(treeNode, values) {
        // 自定义字段值必须为对象类，且不为宛若
        if (!!values && typeof values === "object") {
            // 设置自定义字段值
            let _keys = Object.keys(values)
            for (let i = 0; i < _keys.length; i++) {
                treeNode[_keys[i]] = values[_keys[i]]
            }
        }
    }

    /**
     * description 选中父节点，修改下面所有子节点选中状态
     * @param currentNode  当前操作节点
     * @param values  自定义设置字段值例：{userId: 12221}
     */
    updateTreeDown(currentNode, values) {
        if (!!currentNode["children"] && currentNode["children"].length > 0) {
            currentNode["children"].forEach((item) => {
                item.checked = currentNode.checked
                item.checkFlag = !!item.checked ? "Y" : "N"
                item.isEdit = true
                this._setTreeNodeValue(item, values)
                this.updateTreeDown(item, values)
            })
        }
    }

    /**
     * description 根据当前节点住上查找父节点, 把父节点放到一个数组
     * @param currentNode
     * @param parentTree
     * @param parentList
     * @param values 自定义设置字段值例：{userId: 12221}
     */
    updateTreeUp(currentNode, parentTree, values) {
        let _updateTreeUpFun = (currentNode, parentTree, parentList) => {
            let _upParentTree = parentTree.filter((item) => {
                return currentNode.treeFullPath.indexOf(item.treeFullPath + ".") > -1
                    && !!item["children"] && item["children"].length > 0
            })
            if (_upParentTree.length > 0) {
                parentList.unshift(_upParentTree[0])
                if (!!_upParentTree[0]["children"] && _upParentTree[0]["children"].length > 0) {
                    _updateTreeUpFun(currentNode, _upParentTree[0]["children"], parentList)
                }
            }
        }
        let _parentList = []
        _updateTreeUpFun(currentNode, parentTree, _parentList)
        _parentList.forEach((parentItem) => {
            let _checked = false
            for(let i = 0; i < parentItem["children"].length; i++) {
                if (!!parentItem["children"][i].checked) {
                    _checked = true
                    break
                }
            }
            parentItem.checked = _checked
            parentItem.checkFlag = !!parentItem.checked ? "Y" : "N"
            parentItem.isEdit = true
            this._setTreeNodeValue(parentItem, values)
        })
    }

    /**
     * description 检查按钮是否已授权给前用户职责
     * @param resourceCode
     * @param menuId
     * @param respId
     * @returns {boolean}
     */
    checkMenuResource(resourceCode) {
        let _menuId = this.vm.$route.query.menuId
        let _respId = this.vm.$route.query.respId
        let _menuResourceList = this.vm.$store.state.tabs.menuResourceList[_menuId + "_" + _respId]
        if (!!_menuResourceList) {
            for (let i = 0; i < _menuResourceList.length; i++) {
                if (resourceCode === _menuResourceList[i].resourceCode) {
                    return true
                }
            }
        }
        return false
    }

    /**
     * description 格式数字为带千分位的字符串
     * @param value
     * @returns {string}
     */
    getFormatNumberValue(value) {
        if (value === null || value === undefined || value === "") {
            return ""
        }
        let _valueStr = value.toString()
        // 检查是否带有小数
        if (_valueStr.indexOf(".") > -1) {
            let _intValueStr = _valueStr.substr(0, _valueStr.indexOf("."))
            let _decimalsValueStr = _valueStr.substr(_valueStr.indexOf("."), _valueStr.length)
            let _value = _intValueStr.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + _decimalsValueStr
            return _value
        } else {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        }
    }

    /**
     * description 带千分位的数字字符串转换为数据
     * @param value
     */
    getParserNumberValue(value) {
        if (value === null || value === undefined || value === "") {
            return null
        }
        return value.toString().replace(/\$\s?|(,*)/g, '')
    }

    /**
     * description 获取日期格式化字符串
     * @param columnType
     * @returns {string}
     */
    getFormatDatePattern(columnType) {
        if (columnType === "date" || columnType === "daterange") {
            return "yyyy-MM-dd"
        } else if (columnType === "datetime" || columnType === "datetimerange") {
            return "yyyy-MM-dd HH:mm:ss"
        } else if (columnType === "year") {
            return "yyyy"
        } else if (columnType === "month") {
            return "yyyy-MM"
        }
        return "yyyy-MM-dd"
    }

    /**
     * description 格式化日期
     * @param columnType
     * @param val
     * @returns {*}
     */
    getFormatDateValue(columnType, val) {
        if (!!!val) return val
        if (columnType === "date" || columnType === "daterange") {
            return this.vm.$moment(val).format("YYYY-MM-DD")
        } else if (columnType === "datetime" || columnType === "datetimerange") {
            return this.vm.$moment(val).format("YYYY-MM-DD HH:mm:ss")
        } else if (columnType === "year") {
            return this.vm.$moment(val).format("YYYY")
        } else if (columnType === "month") {
            return this.vm.$moment(val).format("YYYY-MM")
        }
        return val
    }

    getUuid() {
        let _s = [];
        let _hexDigits = "0123456789abcdef";
        for (let i = 0; i < 36; i++) {
            _s[i] = _hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        _s[14] = _hexDigits.substr(Math.floor(Math.random() * 0x10), 1);  // bits 12-15 of the time_hi_and_version field to 0010
        _s[19] = _hexDigits.substr((_s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
        _s[8] = _s[13] = _s[18] = _s[23] = "-";

        let _uuid = _s.join("");
        return _uuid;
    }

    /*设置当前支持PageOffice*/
    setPageOffice() {
        let pageOfficePath = platform.url.fileServer
        this.vm.$nextTick(() => {
            let jqueryScriptTag = document.getElementById('jqueryScriptTag')
            let pageofficeScriptTag = document.getElementById('po_js_main')
            // 如果这个tag不存在，则生成相关代码tag以加载代码
            if (!!!jqueryScriptTag) {
                jqueryScriptTag = document.createElement('script')
                jqueryScriptTag.type = 'text/javascript'
                jqueryScriptTag.src = pageOfficePath + '/jquery.min.js'
                jqueryScriptTag.id = 'jqueryScriptTag'
            }
            if (!!!pageofficeScriptTag) {
                pageofficeScriptTag = document.createElement('script')
                pageofficeScriptTag.type = 'text/javascript'
                pageofficeScriptTag.src = pageOfficePath + '/pageoffice.js'
                pageofficeScriptTag.id = 'po_js_main'
            }
            let s = document.getElementsByTagName('head')[0]
            s.appendChild(jqueryScriptTag)
            jqueryScriptTag.addEventListener('load', () => {
                s.appendChild(pageofficeScriptTag)
            })
        })
    }

    /**
     * @description 打开PageOffice在线编辑的窗口
     * @author lizhen
     * @date 2021-03-11
     * @param fileId
     * @param customParams 自定义参数集 例： param1=value1&param2=value2
     * @param isFullScreen
     */
    pageOfficeOpenWindow(url, fileId, customParams, isFullScreen) {
        let _userInfo = this.vm.$store.state.user.userInfo
        let _fullScreen = 'yes'
        if (isFullScreen === "N") {
            _fullScreen = 'no'
        }
        let _url = `${url}?fileId=${fileId}&AuthorizationCode=${_userInfo.authorizationCode}&Gateway-Tag=${_userInfo.gatewayTag}`
        if (!!customParams) {
            _url = `${url}?fileId=${fileId}&${customParams}&AuthorizationCode=${_userInfo.authorizationCode}&Gateway-Tag=${_userInfo.gatewayTag}`
        }
        POBrowser.openWindowModeless(_url, 'height=700px;fullscreen=' + _fullScreen + ';')
    }

    /* 验证是否为大于0的数字（包括小数) */
    isCheckPositive(val) {
        const regular = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/ //正数（包括小数)
        // regular.test(str) 与 regluar 正则是否匹配
        if (regular.test(val) && val > 0) {
           return true;
        }
        return false;
    }

    /* 验证是否为不小于0的数字（包括小数) */
    isCheckPositiveOrZero(val) {
        const regular = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/ //正数（包括小数)
        // regular.test(str) 与 regluar 正则是否匹配
        if (regular.test(val)) {
            return true;
        }
        return false;
    }

    /* 验证是否为大于0的整数 */
    isCheckPositiveInt(val) {
        const regular =  /^\d+(\.\d+)?$/
        // regular.test(str) 与 regluar 正则是否匹配
        if (regular.test(val) && val > 0) {
           return true;
        }
        return false;
    }

    /**
     *  @description 字节流数组转换为字符串
     *  @author lizhen
     *  @date 2021-07-24
     */
    Uint8ArrayToStr(array) {
        let _out, _i, _len, _c;
        let _char1, _char2;
        _out = "";
        _len = array.length;
        _i = 0;
        while(_i < _len) {
            _c = array[_i++];
            switch(_c >> 4) {
                case 0: case 1: case 2: case 3: case 4: case 5: case 6: case 7:
                    _out += String.fromCharCode(_c);
                    break;
                case 12: case 13:
                    _char1 = array[_i++];
                    _out += String.fromCharCode(((_c & 0x1F) << 6) | (_char1 & 0x3F));
                    break;
                case 14:
                    _char1 = array[_i++];
                    _char2 = array[_i++];
                    _out += String.fromCharCode(((_c & 0x0F) << 12) |
                        ((_char1 & 0x3F) << 6) |
                        ((_char2 & 0x3F) << 0)
                    );
                    break;
            }
        }
        return _out;
    }

    /**
     * @description 检查下载数据是否成功，异常则返回错误信息
     * @param blobData
     */
    blobDownloadProcess(blobData, callback) {
        let _resJson = null
        try {
            // 如果转换JSON成功，则表示后端处理数据失败了。
            _resJson = JSON.parse(this.Uint8ArrayToStr(new Uint8Array(blobData)))
            if (_resJson.status === "E") {
                this.vm.$Message.error(_resJson.msg)
            }
        } catch (e) {
            callback()
        }
    }

    /**接收流数据，并下载保存到本地磁盘*/
    blobDownloadExcel(fileName, blobData) {
        this.blobDownloadProcess(blobData, () => {
            let _blob = new Blob([blobData], {type: 'application/vnd.ms-excel'}) // 构造一个blob对象来处理数据
            let _fileName = fileName + '.xlsx' // 导出文件名
            // 对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
            // IE10以上支持blob但是依然不支持download
            // 支持a标签download的浏览器
            if ('download' in document.createElement('a')) {
                let _link = document.createElement('a') // 创建a标签
                _link.download = _fileName
                _link.style.display = 'none'
                _link.href = URL.createObjectURL(_blob)
                document.body.appendChild(_link)
                // 执行下载
                _link.click()
                // 释放url
                URL.revokeObjectURL(_link.href)
                // 释放标签
                document.body.removeChild(_link)
            } else { // 其他浏览器
                navigator.msSaveBlob(_blob, _fileName)
            }
        })
    }

    /**接收流数据，并下载保存到本地磁盘
     * @param fileName   文件名
     * @param suffixName 扩展名（例：zip）
     * @param blobData
     * */
    blobDownload(fileName, blobData, suffixName) {
        this.blobDownloadProcess(blobData, () => {
            let _blob = new Blob([blobData]) // 构造一个blob对象来处理数据
            let _fileName = fileName + '.' + suffixName // 导出文件名
            // 对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
            // IE10以上支持blob但是依然不支持download
            // 支持a标签download的浏览器
            if ('download' in document.createElement('a')) {
                let _link = document.createElement('a') // 创建a标签
                _link.download = _fileName
                _link.style.display = 'none'
                _link.href = URL.createObjectURL(_blob)
                document.body.appendChild(_link)
                // 执行下载
                _link.click()
                // 释放url
                URL.revokeObjectURL(_link.href)
                // 释放标签
                document.body.removeChild(_link)
            } else { // 其他浏览器
                navigator.msSaveBlob(_blob, _fileName)
            }
        })
    }

    /**文件流数据下载*/
    downloadFile(fileId, fileName) {
        fetchTool.post(api.v2fileDownload + "?id=" + fileId, {}).then(res => {
            this.blobDownloadProcess(res, () => {
                const blob = new Blob([res]) // 构造一个blob对象来处理数据
                // 对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
                // IE10以上支持blob但是依然不支持download
                // 支持a标签download的浏览器
                if ('download' in document.createElement('a')) {
                    const _link = document.createElement('a') // 创建a标签
                    _link.download = fileName
                    _link.style.display = 'none'
                    _link.href = URL.createObjectURL(blob)
                    document.body.appendChild(_link)
                    // 执行下载
                    _link.click()
                    // 释放url
                    URL.revokeObjectURL(_link.href)
                    // 释放标签
                    document.body.removeChild(_link)
                } else { // 其他浏览器
                    navigator.msSaveBlob(blob, fileName)
                }
                this.btnSendTem = false
            })
        })
    }

    /**使用A标签，下载超大文件附件*/
    largeFileDownload(fileId, fileName) {
        let _link = document.createElement('a') // 创建a标签
        _link.download = fileName
        _link.style.display = 'none'
        _link.href = platform.largeFileHost + "/v1/largeFile/download?id=" + fileId
        _link.target = "view_window"
        document.body.appendChild(_link)
        // 执行下载
        _link.click()
        // 释放标签
        document.body.removeChild(_link)

    }

    /**
     * 按查询条件导出数据
     * @param requestUrl  请求业务数据链接
     * @param requestParams 请求参数
     * @param columns 导出字段列表
     * @param fileName
     * @param sheetMaxRow 非必录，默认为5W行
     */
    exportExcel(requestUrl, requestParams, columns, fileName, sheetMaxRow) {
        if (!!!requestUrl) {
            this.$vm.$Message.error("请求数据链接不可为空")
        }
        if (!!!columns) {
            this.$vm.$Message.error("导出字段列表不可为空")
        }
        let _params = {
            requestUrl: requestUrl,
            requestParams: JSON.stringify(requestParams),
            columns: JSON.stringify(columns),
            fileName: fileName,
            sheetMaxRow: !!!sheetMaxRow ? 50000 : sheetMaxRow
        }
        fetch.exportExcelRestful_exportExcel(_params).then(res => {
            this.blobDownloadExcel(fileName, res)
        })
    }

    /**
     * @description 按查询条件导出数据新，增加按页码导出
     * @author lizhen
     * @date 2021-03-16
     * @param requestUrl  请求业务数据链接
     * @param requestParams 请求参数
     * @param columns 导出字段列表
     * @param fileName
     * @param sheetMaxRow 非必录，默认为5W行
     */
    exportExcelNew(requestUrl, requestParams, columns, fileName, pageParams, sheetMaxRow) {
        if (!!!requestUrl) {
            this.$vm.$Message.error("请求数据链接不可为空")
        }
        if (!!!columns) {
            this.$vm.$Message.error("导出字段列表不可为空")
        }

        // 默认取2W行
        let _requestParams = {}
        if (!!requestParams) {
            _requestParams = {
                ...requestParams
            }
        }
        let _maxRow = 500000
        _requestParams.pageRows =_maxRow
        // 设置当前最大行数
        let _pageParams = "pageRows=" + _maxRow
        if (pageParams !== "undefined" && !!pageParams) {
            if (!!pageParams.pageRows) {
                _requestParams.pageRows =  pageParams.pageRows
                _pageParams = "pageRows=" + pageParams.pageRows
            }
            if (!!pageParams.pageIndex) {
                _requestParams.pageIndex =  pageParams.pageIndex
                _pageParams = _pageParams + "&pageIndex=" + pageParams.pageIndex
            }
        }

        let _params = {
            requestUrl: requestUrl + "?" + _pageParams,
            requestParams: JSON.stringify(_requestParams),
            columns: JSON.stringify(columns),
            fileName: fileName,
            sheetMaxRow: !!!sheetMaxRow ? (_maxRow + 1) : sheetMaxRow
        }
        fetch.exportExcelRestful_exportExcel(_params).then(res => {
            this.blobDownloadExcel(fileName, res)
        })
    }

    /**
     * @description 按查询条件导出数据新，增加按页码导出, 定制改出字段，SRM返回信息
     * @author lizhen
     * @date 2021-07-19
     * @param requestUrl  请求业务数据链接
     * @param requestParams 请求参数
     * @customParams  自定义参数：
     *  ｛
     *      responseField： //请求API端返回数据data里面自定义的返回数据字段
     *
     *  ｝
     * @param columns 导出字段列表
     * @param fileName
     * @param sheetMaxRow 非必录，默认为5W行
     */
    customExportExcel(requestUrl, requestParams, columns, customParams, fileName, pageParams, sheetMaxRow) {
        if (!!!requestUrl) {
            this.$vm.$Message.error("请求数据链接不可为空")
        }
        if (!!!columns) {
            this.$vm.$Message.error("导出字段列表不可为空")
        }

        // 默认取2W行
        let _requestParams = {}
        if (!!requestParams) {
            _requestParams = {
                ...requestParams
            }
        }
        let _maxRow = 500000
        _requestParams.pageRows =_maxRow
        // 设置当前最大行数
        let _pageParams = "pageRows=" + _maxRow
        if (pageParams !== "undefined" && !!pageParams) {
            if (!!pageParams.pageRows) {
                _requestParams.pageRows =  pageParams.pageRows
                _pageParams = "pageRows=" + pageParams.pageRows
            }
            if (!!pageParams.pageIndex) {
                _requestParams.pageIndex =  pageParams.pageIndex
                _pageParams = _pageParams + "&pageIndex=" + pageParams.pageIndex
            }
        }

        let _params = {
            requestUrl: requestUrl + "?" + _pageParams,
            requestParams: JSON.stringify(_requestParams),
            columns: JSON.stringify(columns),
            customParams: JSON.stringify(customParams),
            fileName: fileName,
            sheetMaxRow: !!!sheetMaxRow ? (_maxRow + 1) : sheetMaxRow
        }
        fetch.exportExcelRestful_customExportExcel(_params).then(res => {
            this.blobDownloadExcel(fileName, res)
        })
    }

    /**
     * description 获取当前机器公网IP地址, 保存到缓存数据
     *
     */
    setInternetIP(callback) {
        let _ipTag = document.getElementById("ipTag")
        if (!!!_ipTag) {
            _ipTag = document.createElement("script")
            _ipTag.type = "text/javascript"
            _ipTag.src = "http://pv.sohu.com/cityjson?ie=utf-8"
            _ipTag.id = "ipTag"
        }
        let _fn = callback || function(){};
        let _internetIp = null
        document.getElementsByTagName('head')[0].appendChild(_ipTag);
        _ipTag.addEventListener("load", () => {
            _internetIp = returnCitySN["cip"];
            localStorageTool.save("internetIp", _internetIp)
            _fn();
        })
    }

    getInternetIP() {
        let _internetIp = localStorageTool.get("internetIp")
        return _internetIp
    }

    /**
     * @description 传入带参数或不带参数的URL
     *
     * @param url
     * @param type 标记内部用户或者外部用户, 未传值表示：INSIDE：内部用户，   值域：INSIDE：内部用户  EXTERIOR：外部用户
     */
    getExteriorURL(url, pageName, type, params) {
        if (!!!url) return;
        let _exteriorUrlParam = ""
        if (!!!type) {
            type="INSIDE"
            //link=EXTERIOR"
        }
        _exteriorUrlParam += (!!!_exteriorUrlParam ? "" : "&") + "type=" + type
        _exteriorUrlParam += (!!!_exteriorUrlParam ? "" : "&") + "link=EXTERIOR"
        if (url.indexOf("?") === -1) {
            url += "?"
        }
        let _prefixUrl = "/#/iframeBox" + url.substring(0, url.indexOf("?") + 1)
        let _urlParam = url.substring(url.indexOf("?") + 1, url.length)
        _urlParam += (!!!_urlParam ? "" : "&") + "pageName=" + (!!!pageName ? "PAGE" : pageName)
        _urlParam += (!!!_urlParam ? "" : "&") + "M=V"
        _urlParam += (!!!_urlParam ? "" : "&") + "menuId=" + (params !== null && params !== undefined && params.menuId !== undefined ? params.menuId : this.vm.$route.query.menuId)
        _urlParam += (!!!_urlParam ? "" : "&") + "respId=" + (params !== null && params !== undefined && params.respId !== undefined ? params.respId : this.vm.$route.query.respId)
        _exteriorUrlParam += (!!!_exteriorUrlParam ? "" : "&") + "actionId=" + Base64.encodeURI(AESCommon.encrypt(_urlParam))
        return _prefixUrl + _exteriorUrlParam;
    }

    /**
     * @description 切换语言
     * @author lizhen
     * @date 2021-03-12
     *
     * */
    toggleLang(langVal) {
        let _changeLang = {}
        if (!!!langVal || langVal === "CN") {
            _changeLang = {
                "lookupCode": "CN",
                "buOrgId": null,
                "parentLookupValuesId": "",
                "systemCode": "BASE",
                "meaning": "中文",
                "seqNum": 1,
                "description": "",
                "lookupType": "SYSTEM_LANGUAGE",
                "lookupTypeId": 7,
                "lookupValuesId": 10,
                "parentLookupTypeId": null
            }
            sessionStorageTool.save('currentLanguage', _changeLang)
        } else if (langVal === "EN") {
            _changeLang = {
                "lookupCode": "EN",
                "buOrgId": null,
                "parentLookupValuesId": "",
                "systemCode": "BASE",
                "meaning": "English",
                "seqNum": 1,
                "description": "",
                "lookupType": "SYSTEM_LANGUAGE",
                "lookupTypeId": 7,
                "lookupValuesId": 10,
                "parentLookupTypeId": null
            }
            sessionStorageTool.save('currentLanguage', _changeLang)
        }
        this.vm.$store.commit('CHANGE_LANGUAGE', _changeLang)
    }

    /**拆分url，所域名端口号分离，保离URI*/
    splitUrl(url) {
        let _httpIndex = url.indexOf("https://") > -1 ? url.indexOf("https://") + 8 : url.indexOf("http://") + 7;
        let _url = url.substring(_httpIndex, url.length)
        return _url.substring(_url.indexOf("/"), _url.length)
    }

    /**组合完整的URL*/
    mergeUrl(URI) {
        return platform.root + URI
    }

    /**
     * @description SaafPrintJS页面初始化
     * @author lizhen
     * @date 2021-09-23
     *
     */
    initSaafPrintJS() {
        let _printJSPath = "/saaf-print-js-1.5.0"
        this.vm.$nextTick(() => {
            let _saafPrintJSTag = document.getElementById('saafPrintJSTag')
            // 如果这个tag不存在，则生成相关代码tag以加载代码
            if (!!!_saafPrintJSTag) {
                _saafPrintJSTag = document.createElement('script')
                _saafPrintJSTag.type = 'text/javascript'
                _saafPrintJSTag.src = _printJSPath + '/saaf-print.js'
                _saafPrintJSTag.id = 'saafPrintJSTag'
            }
            let _saafPrintCssTag = document.getElementById('saafPrintCssTag')
            // 如果这个tag不存在，则生成相关代码tag以加载代码
            if (!!!_saafPrintCssTag) {
                _saafPrintCssTag = document.createElement("link")
                _saafPrintCssTag.rel = "stylesheet"
                _saafPrintCssTag.href = _printJSPath + "/saaf-print.css"
                _saafPrintCssTag.id = "saafPrintCssTag"
            }
            let _headTag = document.getElementsByTagName("head")[0]
            _headTag.appendChild(_saafPrintCssTag)
            _saafPrintCssTag.addEventListener("load", () => {
                _saafPrintCssTag.loaded = true
            })

            let _bodyTag = document.getElementsByTagName("body")[0]
            _bodyTag.appendChild(_saafPrintJSTag)
            _saafPrintJSTag.addEventListener("load", () => {
                _saafPrintJSTag.loaded = true
            })
        })
    }
}

export default SrmCommonUtils



// WEBPACK FOOTER //
// ./src/utils/SrmCommonUtils.js